import { EXERCISE_INSERT } from './../../../app.constants';
import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';

import { CardSettings } from '@df/models';
import {
    COMMENTS,
    DECREASE_OPERATION,
    EXERCISE_CALCULATION,
    EXERCISE_LOGIC,
    EXERCISE_MAGIC_BOX,
    EXERCISE_SEQUENCE,
    EXERCISE_PUZZLE_TASK,
    EXERCISE_PUZZLE_EXAMPLE,
    EXERCISE_TASK,
    FINISH_LESSON_TIME_SECONDS_FOR_STUDENT,
    GENDER,
    INCREASE_OPERATION,
    LESSON_IN_WORK,
    MAIN_DOMAIN,
    TYPE_TRANSACTION
} from '@app/app.constants';

import { declensionOfNumerals } from '@app/_utils/helpers';
import {
    Character,
    Currency,
    Greeting,
    ICardData,
    Lesson,
    Pupil,
    SmartSprint,
    Answer,
    AppState,
    Habirint,
    CardInterface
} from '@df/interfaces';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { PupilService } from '@app/student/services/pupil.service';
import { TaskService } from '@app/core/services/task.service';
import { CountingService } from '@app/core/services/counting.service';
import { PupilTaskExerciseComponent } from '@app/student/components/pupil-task-exercise/pupil-task-exercise.component';
import { PupilMagicBoxExerciseComponent } from '@app/student/components/pupil-magic-box-exercise/pupil-magic-box-exercise.component';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { PrivilegeService, HabirintService } from '@app/core/services';
import { HandlerService } from '@app/_services/handler.service';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { StateService } from '@app/core/services/state.service';
import { AchievementsService } from '@results/services/achievements.service';
import { IExercise } from '@df/interfaces/exercise';
import { KATEX_FORMAT } from '@app/app.constants';

@Component({
    selector: 'app-pupil-task',
    templateUrl: './pupil-task.component.html',
    styleUrls: ['../../../_pipes/exercise-format.pipe.scss', './pupil-task.component.scss']
})
export class PupilTaskComponent implements OnInit, OnDestroy {
    @Input() isFinishCard: boolean = false;

    @ViewChild(PupilTaskExerciseComponent, { static: true }) private taskExerciseComponent: PupilTaskExerciseComponent;
    @ViewChild(PupilMagicBoxExerciseComponent, { static: true }) private magicBoxComponent: PupilMagicBoxExerciseComponent;
    @ViewChild('solvedModal', { static: true }) solvedModal: ModalDirective;
    @ViewChild('resultModal', { static: true }) resultModal: ModalDirective;
    @ViewChild('sendAnswerErrorMsg', { static: true }) sendAnswerErrorTemplate: TemplateRef<any>;

    GENDER = GENDER;
    pupil: Pupil;
    card: CardInterface;
    lesson_id: number;
    lesson: Lesson;
    studentId;
    studentAnswers: Answer[] = [];
    selectedExercise;
    selectedExerciseIndex: number;
    selectedExerciseAnswer: Answer;
    answer: string = '';
    errorMessage = null;
    correctAnswersCount: number = 0;
    resultPressed = false;
    allCorrect: boolean = false;
    completedExercisesCount: number = 0;
    currentCurrency: Currency;
    main_domain: string = MAIN_DOMAIN;
    greeting: Greeting;
    uncompletedLoopCounter: number = 3;
    timerActivated: boolean = false;
    timerCountVal: string;
    tasksTimer = 0;
    tasksTimerStr: string;

    logic: string = EXERCISE_LOGIC;
    calculation: string = EXERCISE_CALCULATION;
    magic_box: string = EXERCISE_MAGIC_BOX;
    task: string = EXERCISE_TASK;
    sequence: string = EXERCISE_SEQUENCE;
    puzzleTask: string = EXERCISE_PUZZLE_TASK;
    puzzleExample: string = EXERCISE_PUZZLE_EXAMPLE;
    insert: string = EXERCISE_INSERT;
    character: Character = null;
    riskCharacterSelected: boolean = false;
    totalReward: number = 0;
    sequenceInstruction: string;
    selectCharacter;
    hasKairosBonus: boolean;
    typeTransaction = TYPE_TRANSACTION;
    countExerciseCorrect = 0;
    countExerciseInCorrect = 0;
    answerString = '';
    dialogRef: any;
    boxSmartSprints: Array<SmartSprint>;
    modalRef: BsModalRef;
    cardSettings: CardSettings;

    private destroy$: Subject<boolean> = new Subject<boolean>();
    private currentTeacher = '';
    private cardResultId: number;
    private stopInterval;
    private stopTasksInterval;
    private appSate: AppState = {
        user_data: {
            user_session: {}
        }
    };

    constructor(
        private route: ActivatedRoute,
        private pupilService: PupilService,
        private taskService: TaskService,
        private router: Router,
        private _snackBar: MatSnackBar,
        private _location: Location,
        private changeDetector: ChangeDetectorRef,
        private countingService: CountingService,
        private privilegeService: PrivilegeService,
        private stateService: StateService,
        private habirintService: HabirintService,
        private achievementsService: AchievementsService,
        private handlerService: HandlerService,
        public dialog: MatDialog
    ) {}

    ngOnInit(): void {
        this.init();
    }

    messageHandler(msg: string, duration: number = 5000) {
        this._snackBar.open(msg, 'Закрыть', {
            duration: duration,
            verticalPosition: 'top'
        });
    }

    clearAppState() {
        const initAppState = {
            user_data: {
                user_session: {}
            }
        };
        this.stateService.chageAppState(initAppState);
    }

    ngOnDestroy(): void {
        if (this.stopInterval) {
            clearInterval(this.stopInterval);
        }
        if (this.stopTasksInterval) {
            clearInterval(this.stopTasksInterval);
        }
        this.destroy$.next(true);
    }

    openDialog(): void {
        this.dialogRef = this.dialog.open(this.sendAnswerErrorTemplate, {
            width: '50%',
            height: '245px'
        });
    }

    closeDialog(): void {
        this.dialogRef.close();
        this.leavePage();
    }

    sortExercises() {
        this.card.exercises = this.card.exercises.sort((exercise1, exercise2): number => {
            return exercise1.exercise_order > exercise2.exercise_order ? 1 : -1;
        });
    }

    sortSmartSprints(): void {
        this.boxSmartSprints = this.boxSmartSprints.sort((sprint1, sprint2): number => {
            return sprint1.duration > sprint2.duration ? 1 : -1;
        });
    }

    getStudentAnswer(exercise_id): any {
        for (const answer of this.studentAnswers) {
            if (exercise_id === answer.exercise) {
                return answer.shortAnswer;
            }
        }
        return ' ';
    }

    selectExercise(exercise) {
        if (!this.resultPressed) {
            this.selectedExercise = exercise;
            this.selectedExerciseIndex = this.card.exercises.indexOf(exercise);
            this.changeDetector.detectChanges();
            if (exercise.type === EXERCISE_CALCULATION || exercise.type === EXERCISE_SEQUENCE) {
                this.selectedExerciseAnswer = this.getAnswerForExercise(exercise);
                this.getSequenceInstruction(this.card, exercise);
            } else {
                if (this.taskExerciseComponent) {
                    this.taskExerciseComponent.questionAnswers = this.getAnswersForTaskExercise(exercise);
                }
                if (this.magicBoxComponent) {
                    this.magicBoxComponent.old_answer = this.getAnswerForExercise(exercise);
                }
            }
            if (this.selectedExerciseAnswer && this.selectedExerciseAnswer.shortAnswer) {
                this.answerString = this.selectedExerciseAnswer.shortAnswer;
            } else {
                this.answerString = '';
            }
        }
    }

    checkCorrectAnswer(exercise_id): boolean {
        if (this.resultPressed) {
            for (const answer of this.studentAnswers) {
                if (exercise_id === answer.exercise) {
                    if (answer.correct) {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        }
        return false;
    }

    getClass(exercise_id) {
        if (this.resultPressed) {
            if (this.checkCorrectAnswer(exercise_id)) {
                return 'answer-correct';
            } else {
                return 'answer-incorrect';
            }
        }
        return 'pupil-task__pupil__exercise-result__answer';
    }

    getExerciseClass(exercise_id: number): string {
        for (const answer of this.studentAnswers) {
            if (exercise_id === answer.exercise) {
                if (answer.correct) {
                    return 'true';
                } else {
                    return 'false';
                }
            }
        }
        return '';
    }

    private updateUsedPrivileges(): void {
        const { characters } = this.cardSettings;

        if (characters.length) {
            const userId = this.pupil.user.id;
            this.achievementsService.updateUsedPrivileges(userId, characters).subscribe(resp => {
                this.handlerService.checkErrors(resp);

                if (!resp.success) {
                    console.log(resp);
                }
            });
        }
    }

    showResults(): void {
        clearInterval(this.stopTasksInterval);
        this.clearAppState();
        this.hideModal();
        this.selectedExercise = null;
        this.correctAnswersCount = this.getCorrectCount();
        this.countExerciseCorrect = this.correctAnswersCount;
        this.countExerciseInCorrect = this.card.exercises.length - this.countExerciseCorrect;
        this.allCorrect = this.correctAnswersCount === this.card.exercises.length;

        if (Object.keys(this.cardSettings).length !== 0) {
            this.resultPressed = true;
            const card_cost = this.cardSettings.cost;
            let transactionType = this.typeTransaction.TRANSACTION_TYPE_BANK;
            let penalty = 0;

            if (this.allCorrect) {
                this.totalReward = this.cardSettings.reward;
                this.checkSmartSprintsReward();
            }

            if (!this.allCorrect && this.riskCharacterSelected) {
                penalty = this.cardSettings.penalty;
            }

            if (this.lesson.payment_for_task_with_cash) {
                transactionType = this.typeTransaction.TRANSACTION_TYPE_CASH;
            }

            if (this.hasKairosBonus) {
                this.totalReward += this.cardSettings.kairos_bonus;
            }

            this.rollBackTransaction();

            const card_data: ICardData = {
                card: this.card.id,
                student: this.pupil.id,
                earned_amount: this.totalReward && this.allCorrect ? Number(this.totalReward) : 0,
                penalty: penalty,
                cost: card_cost,
                transaction_type: transactionType,
                tasks_time: this.tasksTimer,
                answers: this.studentAnswers
            };

            this.taskService
                .setCardResults(card_data)
                .pipe(takeUntil(this.destroy$))
                .subscribe();

            if (card_cost > 0) {
                if (this.lesson.payment_for_task_with_cash) {
                    this.taskService
                        .moneyOperation(
                            this.pupil.id,
                            card_cost,
                            INCREASE_OPERATION,
                            COMMENTS.BUY_WITH_CASH,
                            this.card.id
                        )
                        .subscribe(() => {
                            this.taskService
                                .moneyOperation(
                                    this.pupil.id,
                                    card_cost,
                                    DECREASE_OPERATION,
                                    COMMENTS.BUY_WITH_CASH,
                                    this.card.id
                                )
                                .pipe(takeUntil(this.destroy$))
                                .subscribe();
                        });
                } else {
                    this.taskService
                        .moneyOperation(this.pupil.id, card_cost, DECREASE_OPERATION, COMMENTS.BUY, this.card.id)
                        .pipe(takeUntil(this.destroy$))
                        .subscribe();
                }
            }

            if (this.allCorrect) {
                if (this.totalReward > 0) {
                    setTimeout(() => {
                        this.taskService
                            .moneyOperation(
                                this.pupil.id,
                                this.totalReward,
                                INCREASE_OPERATION,
                                COMMENTS.REWARD,
                                this.card.id
                            )
                            .pipe(takeUntil(this.destroy$))
                            .subscribe(() => {
                                console.log('moneyOperation 1');
                                if (this.lesson.reward_with_cash) {
                                    this.taskService
                                        .moneyOperation(
                                            this.pupil.id,
                                            this.totalReward,
                                            DECREASE_OPERATION,
                                            COMMENTS.REWARD_WITH_CASH,
                                            this.card.id
                                        )
                                        .pipe(takeUntil(this.destroy$))
                                        .subscribe(() => console.log('moneyOperation 2'));
                                }
                            });
                    }, 2500);
                }
            } else {
                if (this.riskCharacterSelected) {
                    if (penalty !== 0) {
                        setTimeout(() => {
                            this.taskService
                                .moneyOperation(
                                    this.pupil.id,
                                    penalty,
                                    DECREASE_OPERATION,
                                    COMMENTS.PENALTY,
                                    this.card.id
                                )
                                .pipe(takeUntil(this.destroy$))
                                .subscribe();
                        }, 1000);
                    }
                }
            }
            this.taskService
                .getGreetings(String(this.allCorrect))
                .pipe(takeUntil(this.destroy$))
                .subscribe((next: any) => {
                    this.greeting = next;
                });

            this.updateUsedPrivileges();
        } else {
            this.openDialog();
        }
        this.selectedExerciseIndex = null;
    }

    getClassForWord(word) {
        for (const sAnswer of this.studentAnswers) {
            if (word === sAnswer.shortAnswer || word === sAnswer.fullAnswer) {
                return 'true';
            }
        }
        return 'false';
    }

    getStudentAnswerForQuestion(exercise_id: number, question_id: number): any {
        for (const answer of this.studentAnswers) {
            if (exercise_id === answer.exercise) {
                if (question_id === answer.question) {
                    return answer.shortAnswer;
                }
            }
        }
    }

    selectNextExercise() {
        const next_exercise_index = this.selectedExerciseIndex + 1;
        const nonAnsweredExercises: number[] = this.getExerciseIDWithoutAnswer();

        if (next_exercise_index >= this.card.exercises.length) {
            if (nonAnsweredExercises.length > 0 && this.uncompletedLoopCounter > 0) {
                this.uncompletedLoopCounter--;
                this.selectExercise(this.getExerciseById(nonAnsweredExercises[0]));
                return;
            }
            this.showModal();
        }
        if (next_exercise_index < this.card.exercises.length) {
            this.selectExercise(this.card.exercises[next_exercise_index]);
            if (
                this.selectedExercise.type === EXERCISE_CALCULATION ||
                this.selectedExercise.type === EXERCISE_SEQUENCE ||
                this.selectedExercise.type === EXERCISE_INSERT ||
                this.selectedExercise.type === EXERCISE_PUZZLE_EXAMPLE ||
                this.selectedExercise.type === EXERCISE_PUZZLE_TASK
            ) {
                this.selectedExerciseAnswer = this.getAnswerForExercise(this.card.exercises[next_exercise_index]);
                if (this.selectedExerciseAnswer) {
                    this.answerString = this.selectedExerciseAnswer.shortAnswer;
                }
            } else {
                this.taskExerciseComponent.questionAnswers = this.getAnswersForTaskExercise(
                    this.card.exercises[next_exercise_index]
                );
            }
        } else {
            if (this.card.exercises.length <= this.completedExercisesCount) {
                this.showModal();
            } else {
                if (this.uncompletedLoopCounter > 0) {
                    this.selectExercise(this.getExerciseById(nonAnsweredExercises[0]));
                } else {
                    this.selectExercise(this.card.exercises[0]);
                }
            }
        }
    }

    getAnswers(answer) {
        const isAnswerAdded = this.studentAnswers.some(item => item.exercise === answer.exercise);
        if (isAnswerAdded) {
            this.replaceAnswer(answer);
        } else {
            this.studentAnswers.push(answer);
        }
    }

    exerciseCompleted(completed: boolean) {
        if (completed) {
            if (this.completedExercisesCount < this.card.exercises.length) {
                this.completedExercisesCount++;
            }
            if (this.selectedExercise.questions && this.selectedExercise.questions.length !== 0) {
                this.selectNextExercise();
                return;
            }
            if (
                this.selectedExercise.type === EXERCISE_CALCULATION ||
                this.selectedExercise.type === EXERCISE_MAGIC_BOX ||
                this.selectedExercise.type === EXERCISE_SEQUENCE ||
                this.selectedExercise.type === EXERCISE_PUZZLE_EXAMPLE ||
                this.selectedExercise.type === EXERCISE_PUZZLE_TASK
            ) {
                this.selectNextExercise();
                return;
            }
        }
    }

    newLoop() {
        this.selectExercise(this.card.exercises[0]);
        this.selectedExerciseAnswer = this.getAnswerForExercise(this.card.exercises[0]);
        if (
            this.card.exercises[0].type === EXERCISE_CALCULATION ||
            this.card.exercises[0].type === EXERCISE_SEQUENCE ||
            this.card.exercises[0].type === EXERCISE_INSERT ||
            this.selectedExercise.type === EXERCISE_PUZZLE_EXAMPLE ||
            this.selectedExercise.type === EXERCISE_PUZZLE_TASK
        ) {
            if (this.selectedExerciseAnswer) {
                this.answerString = this.selectedExerciseAnswer.shortAnswer;
            } else {
                this.answerString = '';
            }
        } else if (this.card.exercises[0].type === this.magic_box) {
            this.magicBoxComponent.old_answer = this.getAnswerForExercise(this.card.exercises[0]);
            this.magicBoxComponent.ngOnInit();
        } else {
            this.taskExerciseComponent.questionAnswers = this.getAnswersForTaskExercise(this.card.exercises[0]);
        }
        this.correctAnswersCount = this.getCorrectCount();
        this.hideModal();
    }

    exerciseCorrect(isCorrect: boolean) {
        if (isCorrect) {
            this.correctAnswersCount++;
        }
    }

    showModal(): void {
        this.solvedModal.show();
    }

    hideModal(): void {
        this.solvedModal.hide();
    }

    closeResultModal(): void {
        this.resultModal.hide();
    }

    replaceAnswer(answer: Answer) {
        for (const answ of this.studentAnswers) {
            if (
                answ.exercise === answer.exercise &&
                ((answ.question != null && answ.question === answer.question) || answ.question == null)
            ) {
                this.studentAnswers[this.studentAnswers.indexOf(answ)] = answer;
                return true;
            }
        }
        return false;
    }

    getAnswerForExercise(exercise) {
        for (const answ of this.studentAnswers) {
            if (exercise.id === answ.exercise) {
                return answ;
            }
        }
        return null;
    }

    exitClicked() {
        this.clearAppState();
        const profile = JSON.parse(localStorage.getItem('profile'));

        if ((profile && this.lesson.smart_sprints.length) || (profile && this.lesson.is_online)) {
            this.router.navigate(['profile/awards', profile.user.id]);
            return;
        }

        this.router.navigate(['/student/class_list', this.pupil.student_class]);
    }

    getCorrectCount(): number {
        let correctCount: number = 0;
        for (const answ of this.studentAnswers) {
            if (answ.correct) {
                correctCount++;
            }
        }
        return correctCount;
    }

    getAnswersForTaskExercise(exercise) {
        const answers: Answer[] = [];
        for (const answer of this.studentAnswers) {
            if (exercise.id === answer.exercise) {
                answers.push(answer);
            }
        }
        return answers;
    }

    getExerciseIDWithoutAnswer(): number[] {
        if (this.card) {
            const answeredExercisesId: number[] = [];
            const nonAnsweredExerciseID: number[] = [];
            for (const answer of this.studentAnswers) {
                if (!answeredExercisesId.includes(answer.exercise) && answer.shortAnswer) {
                    answeredExercisesId.push(answer.exercise);
                }
            }

            for (const exercise of this.card.exercises) {
                if (answeredExercisesId.indexOf(exercise.id) === -1) {
                    nonAnsweredExerciseID.push(exercise.id);
                }
            }
            return nonAnsweredExerciseID;
        }
    }

    getExerciseById(exercise_id: number): any {
        for (const exercise of this.card.exercises) {
            if (exercise_id === exercise.id) {
                return exercise;
            }
        }
        return null;
    }

    getExerciseAnswerForMagicBox(exercise_id: number): Array<any> | null {
        const answer_str = this.getStudentAnswer(exercise_id);
        if (!answer_str || answer_str === ' ') {
            return null;
        }
        return JSON.parse(answer_str);
    }

    getCardCssClass(card) {
        if (card && card.exercises[0].type === this.magic_box) {
            return 'pupil_mobile_keybord';
        }
        return 'pupil_personal';
    }

    leavePage(): void {
        this.clearAppState();
        const profile = JSON.parse(localStorage.getItem('profile'));

        if ((profile && this.lesson.smart_sprints.length) || (profile && this.lesson.is_online)) {
            this.router.navigate(['profile/awards', profile.user.id]);
            return;
        }

        this._location.back();
    }

    getSequenceInstruction(card: CardInterface, exercise) {
        for (const f of card.box.files) {
            if (f.type === exercise.type) {
                this.sequenceInstruction = f.instruction;
                return;
            }
        }
    }

    declensionOfNumerals(amount: number): string {
        return declensionOfNumerals(amount, this.currentCurrency);
    }

    init(): void {
        this.applyStatePage();
        this.route.params.pipe(takeUntil(this.destroy$)).subscribe((params: Params) => {
            const card_id = params['card_id'];
            this.studentId = params['pupil_id'];
            if (!card_id) {
                const successMsg = 'Не верный идентификатор карточки';
                this.messageHandler(successMsg);
                return;
            }

            this.taskService.checkCard(card_id, this.studentId).subscribe(resp => {
                if (resp.error) {
                    this.messageHandler(resp.error);
                    this._location.back();
                    return;
                }

                this.taskService.getCard(card_id);
                this.lesson_id = params['lesson_id'];
                this.riskCharacterSelected = this.pupilService.getRiskCharacter();
                this.selectCharacter = this.pupilService.getSelectCharacter();
                this.getCardData(card_id);
                this.taskService.getLesson(this.lesson_id).subscribe(resp => {
                    this.lesson = resp;
                    this.getCurrency();
                    if (this.lesson.smart_sprints.length > 0) {
                        this.startTasksTimer();
                    }
                });

                this.pupilService.queryPupil(this.studentId).subscribe(pupil => {
                    this.pupil = pupil;
                });
                this.taskService
                    .pollingPupilGet(this.lesson_id, 4000)
                    .pipe(takeUntil(this.destroy$))
                    .subscribe((response: any) => {
                        this.lesson = response;
                        if (this.lesson.status !== LESSON_IN_WORK && !this.timerActivated) {
                            this.startFinishTimer();
                        }
                    });
            });
        });
    }

    private startFinishTimer(): void {
        this.timerActivated = true;
        let endWaitInSec = FINISH_LESSON_TIME_SECONDS_FOR_STUDENT;
        this.stopInterval = setInterval(() => {
            --endWaitInSec;
            this.timerCountVal = this.taskService.converSecondsToMinuteString(endWaitInSec);
            if (this.lesson.status === LESSON_IN_WORK) {
                this.timerActivated = false;
                clearInterval(this.stopInterval);
                return;
            }
            if (endWaitInSec < 1) {
                clearInterval(this.stopInterval);
                this.exitClicked();
            }
        }, 1000);
    }

    private startTasksTimer(): void {
        this.stopTasksInterval = setInterval(() => {
            this.tasksTimer += 1;
            this.tasksTimerStr = this.taskService.converSecondsToMinuteString(this.tasksTimer);
            this.saveStatePage();
            if (this.lesson.status !== LESSON_IN_WORK) {
                clearInterval(this.stopTasksInterval);
                return;
            }
        }, 1000);
    }

    private getCardData(cardId): void {
        this.taskService.getCard(cardId).subscribe(response => {
            this.card = response;
            if (this.lesson.is_habirint) {
                this.sendHabirintData();
            }
            this.boxSmartSprints = response.box.smart_sprints;
            this.sortSmartSprints();
            this.sortExercises();
            this.checkForKairosBonus();
            if (response.prev_results) {
                this.cardResultId = Number(response.prev_results.card_result_id);
            }
            const data = {
                student_id: this.studentId,
                card_id: this.card.id,
                risk: false,
                card_result_id: this.cardResultId
            };
            if (this.riskCharacterSelected) {
                data.risk = true;
            }
            this.countingService
                .getCardSettings(data)
                .pipe(takeUntil(this.destroy$))
                .subscribe(resp => {
                    this.cardSettings = resp;
                });
            this.selectExercise(this.card.exercises[0]);
        });
    }

    private checkForKairosBonus(): void {
        this.privilegeService
            .checkForKairosBonus(this.studentId, this.card.id)
            .pipe(takeUntil(this.destroy$))
            .subscribe((hasKairosBonus: boolean) => {
                this.hasKairosBonus = hasKairosBonus;
            });
    }

    private rollBackTransaction(del = false): void {
        this.taskService
            .rollBackTransactions(this.card.id, this.currentTeacher, del)
            .pipe(takeUntil(this.destroy$))
            .subscribe();
    }

    private getCurrency() {
        this.taskService
            .getCurrencyForLesson(this.lesson)
            .pipe(takeUntil(this.destroy$))
            .subscribe(response => {
                if (response.count !== 0) {
                    const currencies: Currency[] = response.results;
                    this.currentCurrency = currencies[0];
                }
            });
    }

    private checkSmartSprintsReward() {
        for (const sprintItem of this.boxSmartSprints) {
            if (this.tasksTimer <= sprintItem.duration) {
                this.totalReward = sprintItem.reward;
                break;
            }
            this.totalReward = 0;
        }
    }

    getNextCard() {
        if (this.lesson.smart_sprints.length || this.lesson.is_online) {
            this.router.navigate(['student/smart_sprint/pupil', this.studentId, this.lesson.id]);
            return;
        }
        this.router.navigate(['/student/pupil', this.studentId]);
    }

    applyStatePage() {
        const appState = this.stateService.appState;

        if (appState) {
            this.tasksTimer = appState.user_data.user_session.tasks_timer || 0;
            this.tasksTimerStr = this.taskService.converSecondsToMinuteString(this.tasksTimer);

            this.studentAnswers = appState.user_data.user_session.student_answers || [];
            return;
        }
    }

    saveStatePage() {
        this.appSate.user_data.user_session.tasks_timer = this.tasksTimer;
        this.appSate.user_data.user_session.student_answers = this.studentAnswers;
        this.stateService.chageAppState(this.appSate);
    }

    private sendHabirintData(): void {
        const data: Habirint = {
            student_id: this.pupil.id,
            coach_id: this.pupilService.getCoachPupil.id,
            lesson_id: this.lesson.id,
            level: Number(this.card.box.level),
            card_id: this.card.id
        };

        this.habirintService.createHabirint(data).subscribe();
    }

    isKatexFormat(exercise: IExercise): boolean {
        return exercise.format_type === KATEX_FORMAT;
    }

    checkAnswer(answer: any): void {
        const correctAnswers = this.selectedExercise.exercise_correct_answers || this.selectedExercise.answers;
        if (correctAnswers && correctAnswers.length > 0) {
            answer.correct = correctAnswers.some(i => this.checkSpace(i.shortAnswer, answer.shortAnswer));
        }
        this.exerciseCorrect(answer.correct);
        this.getAnswers(answer);
    }

    private checkSpace(correctAnswerValue: string, answerValue: string): boolean {
        const clearCorrectAnswerValue = correctAnswerValue.replace(/\s/g, '');
        const clearAnswerValue = answerValue.replace(/\s/g, '');
        return clearCorrectAnswerValue === clearAnswerValue;
    }
}
